import React, { useEffect, useState } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import "@splidejs/react-splide/css/skyblue";
import ourAchievementIcon from "../assets/images/our_achievements_icon.svg";

import ourAchievements1 from "../assets/images/our_achievements/our_achievements_1.png";
import ourAchievements2 from "../assets/images/our_achievements/our_achievements_2.png";
import ourAchievements3 from "../assets/images/our_achievements/our_achievements_3.png";
import ourAchievements4 from "../assets/images/our_achievements/our_achievements_4.png";
import ourAchievements5 from "../assets/images/our_achievements/our_achievements_5.png";
import ourAchievements6 from "../assets/images/our_achievements/our_achievements_6.png";
import ourAchievements7 from "../assets/images/our_achievements/our_achievements_7.png";
import ourAchievements8 from "../assets/images/our_achievements/our_achievements_8.png";
import ourAchievements9 from "../assets/images/our_achievements/our_achievements_9.png";
import ourAchievements10 from "../assets/images/our_achievements/our_achievements_10.jpg";

// const ourAchievements = [
//   {
//     image: ourAchievements2,
//     title:
//       "Hemos brindado apoyo integral a más de 230 sobrevivientes de trata, proporcionando servicios esenciales como alojamiento seguro, atención médica, asesoría legal, y apoyo psicológico.",
//   },
//   {
//     image: ourAchievements3,
//     title:
//       "Nos aseguramos de que cada sobreviviente reciba un trato respetuoso y equitativo por parte de las autoridades, garantizando que sus derechos sean protegidos.",
//   },
//   {
//     image: ourAchievements4,
//     title:
//       "Ofrecemos programas de capacitación y asesoría basados en los últimos avances neurocientíficos enfocados a superar el trauma y mejorar su bienestar mental y emocional.",
//   },
//   {
//     image: ourAchievements5,
//     title:
//       "Abrimos el primer refugio de alta seguridad en Quintana Roo. Este refugio ofrece un entorno seguro y confidencial, donde las sobrevivientes pueden recibir el apoyo necesario para su recuperación.",
//   },
//   {
//     image: ourAchievements6,
//     title:
//       "Trabajamos con el Instituto Nacional de Psiquiatría Ramón de la Fuente y el Banco Interamericano de Desarrollo en la elaboración de un libro sobre Trata de personas y nuestro modelo de atención.",
//   },
//   {
//     image: ourAchievements7,
//     title:
//       "Muchas de las sobrevivientes se convirtieron en activistas, quienes a través de talleres, actividades de prevención y conferencias, crean conciencia acerca de la trata de personas.",
//   },
//   {
//     image: ourAchievements8,
//     title:
//       "Implementamos programas de prevención en comunidades vulnerables, educando sobre los riesgos de la trata y explotación. Programas que incluyen campañas de concienciación, talleres en escuelas y organizaciones.",
//   },
//   {
//     image: ourAchievements9,
//     title:
//       "Somos parte de un proyecto que realizan la Oficina de las Naciones Unidas contra el Crimen y la Droga (UNODC) y la Secretaría de Gobernación para el fortalecimiento de refugios.",
//   },
//   {
//     image: ourAchievements10,
//     title:
//       "Apoyamos a las sobrevivientes para que continúen su educación a nivel postgrado, brindándoles becas y recursos necesarios. Siendo la educación una herramienta poderosa para su emancipación y empoderamiento.",
//   },
//   {
//     image: ourAchievements1,
//     title:
//       "Proporcionamos apoyo especializado a los hijos e hijas de las sobrevivientes, asegurando que reciban atención psicológica, educativa y emocional para darles una vida digna.",
//   },
// ];

function SliderBlog() {
  const options = {
    type: "loop",
    perPage: 2.5,
    arrows: false,
    perMove: 1,
    pagination: true,
    autoplay: true,
    gap: "33px",
    breakpoints: {
      768: {
        perPage: 1,
      },
    },
  };

  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const getAllPosts = async () => {
      let allPosts = [];
      let page = 1;
      let more = true;

      while (more) {
        const res = await fetch(
          `https://blog.fundacioncaminoacasa.org/wp-json/wp/v2/posts?_embed&per_page=100&page=${page}`
        );

        if (!res.ok) {
          more = false;
          break;
        }

        const data = await res.json();
        allPosts = [...allPosts, ...data];

        if (data.length < 100) {
          more = false;
        } else {
          page++;
        }
      }

      setPosts(allPosts);
    };

    getAllPosts();
  }, []);

  return (
    <>
      <Splide options={options} className="slider-blog">
        {posts.map((post, index) => (
          <SplideSlide key={index}>
            <div className="bg-[#EBE7DF] w-full">
              <div className="flex">
                <img
                  src={
                    post._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                    "https://via.placeholder.com/600x400?text=No+Image"
                  }
                  alt={post.title.rendered}
                  className=""
                />
              </div>
              <div className="flex flex-col px-4 pt-4">
                <div className="flex justify-between">
                  <div className="text-[#303030] lg:max-w-[93%] text-start font-bold font-LibreFranklin text-[18px] lg:text-[32px] xl:leading-[116%] whitespace-nowrap overflow-hidden text-ellipsis">
                    {post.title.rendered.replace(/<[^>]+>/g, "")
                      .replace("&hellip;", "…")}
                  </div>
                  <div className="text-[#303030] text-end font-bold font-montserrat text-[10px] xl:leading-[116%] pt-1">
                    {post.acf.ciudad}, {post.acf.fecha}
                  </div>
                </div>
                <div className="text-[#303030] w-full lg:max-w-[90%] text-start font-semibold font-montserrat text-[18px] xl:leading-[116%] mb-4 pt-1 text-truncate-3">
                  <p>
                    {post.excerpt.rendered
                      .replace(/<[^>]+>/g, "")
                      .replace("&hellip;", "…")}
                  </p>
                </div>

                <div className="text-[#303030] text-start font-extrabold font-montserrat text-[16px] xl:leading-[116%] xs:mb-10 underline">
                  <a href={post.link}>Leer Más</a>
                </div>
              </div>
            </div>
          </SplideSlide>
        ))}
      </Splide>
    </>
  );
}

export default SliderBlog;
